import { useState, useEffect } from 'react';

const SILENT_VOICE_ID = '__silent__';
const HINDI_INDIAN_VOICE_ID = '__hindi_india_voice__';

const useSpeechSynthesis = () => {
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState({
    name: HINDI_INDIAN_VOICE_ID,
    lang: 'hi-IN',
  });
  const synth = window.speechSynthesis;

  useEffect(() => {
    const handleVoicesChanged = () => {
      if (!synth) return;
      const availableVoices = synth.getVoices();

      // --- THIS IS THE KEY LOGIC CHANGE ---

      // 1. Filter for preferred voices first (Indian English and Hindi)
      const indianVoices = availableVoices.filter(
        voice => voice.lang === 'en-IN' || voice.lang === 'hi-IN'
      );
      
      // 2. As a fallback, include other high-quality English voices
      const otherGoodVoices = availableVoices.filter(
        voice => voice.lang.startsWith('en-') && !indianVoices.includes(voice)
      );

      // 3. Combine them, with Indian voices at the top of the list
      const finalVoices = [...indianVoices, ...otherGoodVoices];

      setVoices(finalVoices);

      // ------------------------------------
    };

    if (synth) {
      synth.addEventListener('voiceschanged', handleVoicesChanged);
      handleVoicesChanged(); // Initial call
      return () => {
        synth.removeEventListener('voiceschanged', handleVoicesChanged);
      };
    }
  }, [synth, selectedVoice]);

  const speak = (text) => {
    if (!synth || !text || !selectedVoice) return;
    if (selectedVoice.name === SILENT_VOICE_ID) return;

    if (synth.speaking) {
      synth.cancel();
    }
    
    const utterance = new SpeechSynthesisUtterance(text);

    const isHindiIndiaMode = selectedVoice.name === HINDI_INDIAN_VOICE_ID;

    if (isHindiIndiaMode) {
      const hindiVoices = voices.filter(v => v.lang === 'hi-IN' || v.lang.startsWith('hi'));
      const preferredHindiVoice =
        hindiVoices.find(v => v.lang === 'hi-IN' && v.name.toLowerCase().includes('google')) ||
        hindiVoices.find(v => v.lang === 'hi-IN') ||
        hindiVoices[0];

      if (preferredHindiVoice) {
        utterance.voice = preferredHindiVoice;
        utterance.lang = preferredHindiVoice.lang;
      } else {
        utterance.lang = 'hi-IN';
      }
      utterance.pitch = 1;
      utterance.rate = 0.8;
    } else {
      utterance.voice = selectedVoice;
      utterance.lang = selectedVoice.lang;
      utterance.pitch = 1;
      utterance.rate = 0.8;
    }

    synth.speak(utterance);
  };

  return {
    voices,
    selectedVoice,
    setSelectedVoice,
    speak,
  };
};

export default useSpeechSynthesis;
export { SILENT_VOICE_ID, HINDI_INDIAN_VOICE_ID };
